import { MenuProps } from "antd";
import { AuthContextType } from "@/contexts";
import { UserPermission } from "@/domains/user";
import { type I18nT } from "@/plugins/i18n";

type MenuItem = Required<MenuProps>["items"][number];

// TODO: refactor by permission:route map
export const getMenu = (auth: AuthContextType, t: I18nT) => {
  const items: MenuItem[] = [];

  items.push({
    label: t("systems.Menu.overview"),
    key: "/",
  });

  const operatorReportItems: MenuItem[] = [];

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_member_deposit_records,
    )
  )
    operatorReportItems.push({
      label: t("systems.Menu.memberDepositReport"),
      key: "/operator/reports/member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_member_withdraw_records,
    )
  )
    operatorReportItems.push({
      label: t("systems.Menu.memberWithdrawReport"),
      key: "/operator/reports/member-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_reports_withdraw_records))
    operatorReportItems.push({
      label: t("systems.Menu.tenantDepositReport"),
      key: "/operator/reports/tenant-deposit",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_reports_deposit_records))
    operatorReportItems.push({
      label: t("systems.Menu.tenantWithdrawReport"),
      key: "/operator/reports/tenant-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_operator_reports_self_deposit_records)
  )
    operatorReportItems.push({
      label: t("systems.Menu.selfDepositReport"),
      key: "/operator/reports/self-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_operator_reports_self_withdraw_records,
    )
  )
    operatorReportItems.push({
      label: t("systems.Menu.selfWithdrawReport"),
      key: "/operator/reports/self-withdraw",
    });

  if (operatorReportItems.length)
    items.push({
      label: t("systems.Menu.operatorReports"),
      key: "/operator/reports",
      children: operatorReportItems,
    });

  const operatorManagementItems: MenuItem[] = [];

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_wallets))
    operatorManagementItems.push({
      label: t("systems.Menu.walletsManagement"),
      key: "/operator/management/wallets",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_tenants))
    operatorManagementItems.push({
      label: t("systems.Menu.tenantsManagement"),
      key: "/operator/management/tenants",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_custom_deposit,
    )
  )
    operatorManagementItems.push({
      label: t("systems.Menu.createCustomDeposit"),
      key: "/operator/management/create-custom-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_custom_withdraw,
    )
  )
    operatorManagementItems.push({
      label: t("systems.Menu.createCustomWithdraw"),
      key: "/operator/management/create-custom-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_options))
    operatorManagementItems.push({
      label: t("systems.Menu.operatorOptionsManagement"),
      key: "/operator/management/options",
    });

  if (auth.hasPerm(UserPermission.show_menu_operator_managements_operations))
    operatorManagementItems.push({
      label: t("systems.Menu.operationsManagement"),
      key: "/operator/management/operations",
    });

  if (operatorManagementItems.length)
    items.push({
      label: t("systems.Menu.operatorManagement"),
      key: "/operator/management",
      children: operatorManagementItems,
    });

  const tenantReportItems: MenuItem[] = [];

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_member_deposit_records)
  )
    tenantReportItems.push({
      label: t("systems.Menu.memberDepositReport"),
      key: "/tenant/reports/member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_reports_member_withdraw_records,
    )
  )
    tenantReportItems.push({
      label: t("systems.Menu.memberWithdrawReport"),
      key: "/tenant/reports/member-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_self_deposit_records)
  )
    tenantReportItems.push({
      label: t("systems.Menu.selfDepositReport"),
      key: "/tenant/reports/self-deposit",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_self_withdraw_records)
  )
    tenantReportItems.push({
      label: t("systems.Menu.selfWithdrawReport"),
      key: "/tenant/reports/self-withdraw",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_daily_deposit_records)
  )
    tenantReportItems.push({
      label: t("systems.Menu.dailyDepositReport"),
      key: "/tenant/reports/daily-deposit",
    });

  if (
    auth.hasPerm(UserPermission.show_menu_tenant_reports_daily_withdraw_records)
  )
    tenantReportItems.push({
      label: t("systems.Menu.dailyWithdrawReport"),
      key: "/tenant/reports/daily-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_reports_transfers))
    tenantReportItems.push({
      label: t("systems.Menu.transfersReport"),
      key: "/tenant/reports/transfers",
    });

  if (tenantReportItems.length)
    items.push({
      label: t("systems.Menu.tenantReports"),
      key: "/tenant/reports",
      children: tenantReportItems,
    });

  const tenantManagementItems: MenuItem[] = [];

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_member_deposit,
    )
  )
    tenantManagementItems.push({
      label: t("systems.Menu.createMemberDeposit"),
      key: "/tenant/management/create-member-deposit",
    });

  if (
    auth.hasPerm(
      UserPermission.show_menu_tenant_management_create_member_withdraw,
    )
  )
    tenantManagementItems.push({
      label: t("systems.Menu.createMemberWithdraw"),
      key: "/tenant/management/create-member-withdraw",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_members))
    tenantManagementItems.push({
      label: t("systems.Menu.membersManagement"),
      key: "/tenant/management/members",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_options))
    tenantManagementItems.push({
      label: t("systems.Menu.tenantOptionsManagement"),
      key: "/tenant/management/options",
    });

  if (auth.hasPerm(UserPermission.show_menu_tenant_managements_operations))
    tenantManagementItems.push({
      label: t("systems.Menu.operationsManagement"),
      key: "/tenant/management/operations",
    });

  if (tenantManagementItems.length)
    items.push({
      label: t("systems.Menu.tenantManagement"),
      key: "/tenant/management",
      children: tenantManagementItems,
    });

  return items;
};
